import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css/navigation';
import { Autoplay } from 'swiper/modules';
import { useGetApiV1ClientAdvertisementsQuery } from 'service/api/allApis';
import { Link } from 'react-router-dom';
import { Skeleton } from 'components/common/skeleton';

const TopAdvertisings = () => {
    const { data, isLoading } = useGetApiV1ClientAdvertisementsQuery({
        isPaginated: false,
    });

    return (
        <div className="md:w-[925px] lg:w-[1070px] mx-auto z-10 relative md:-mt-12 mb-10">
            <Swiper
                className="w-full duration-150 m-0 p-2"
                autoplay={{
                    delay: 3000,
                    disableOnInteraction: false,
                }}
                breakpoints={{
                    0: {
                        slidesPerView: 2,
                    },
                    480: {
                        slidesPerView: 3,
                    },
                    768: {
                        slidesPerView: 4,
                    },
                    1070: {
                        slidesPerView: 5,
                    },
                }}
                effect="fade"
                fadeEffect={{
                    crossFade: true,
                }}
                loop={true}
                modules={[Autoplay]}
            >
                {isLoading &&
                    [...Array(9)].map((_, idx) => (
                        <SwiperSlide key={idx} className="px-2.5">
                            <Skeleton className="w-full h-24 border border-dark-20 rounded-md block" />
                        </SwiperSlide>
                    ))}
                {data?.items?.map((item, idx) => (
                    <SwiperSlide key={idx} className="px-2.5">
                        <Link
                            to={item.url!}
                            className="block rounded-md border border-dark-20 w-full h-24 overflow-hidden cursor-pointer group hover:scale-105 transition"
                        >
                            <img
                                src={item.image!}
                                alt={item.url ?? ''}
                                className="w-full h-full group-hover:scale-95 transition"
                                onError={(e) => {
                                    e.currentTarget.onerror = null;
                                    e.currentTarget.src = '/not-found.png';
                                }}
                            />
                        </Link>
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    );
};

export default TopAdvertisings;
